
import React from 'react';

interface HeroStatsProps {
    stats: {
        totalProperties: number;
        complianceScore: number;
        expiringSoon: number;
        overdue: number;
    };
}

const HeroStats: React.FC<HeroStatsProps> = ({ stats }) => {

    const getScoreColor = (score: number) => {
        if (score >= 80) return 'text-green-500';
        if (score >= 50) return 'text-yellow-500';
        return 'text-red-500';
    };

    return (
        <section id="dashboard" className="py-8 bg-gradient-to-r from-green-600 to-green-700 text-white shadow-lg">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6">

                    <div className="bg-white bg-opacity-10 backdrop-blur-md rounded-xl p-6 hover:bg-opacity-20 transition-all border border-white border-opacity-20 shadow-xl">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-green-50 text-sm font-medium tracking-wide">Total Properties</p>
                                <p className="text-3xl font-bold mt-1">{stats.totalProperties}</p>
                            </div>
                            <div className="w-12 h-12 bg-white bg-opacity-20 rounded-lg flex items-center justify-center shadow-inner">
                                <i className="fas fa-home text-xl text-white"></i>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white bg-opacity-10 backdrop-blur-md rounded-xl p-6 hover:bg-opacity-20 transition-all border border-white border-opacity-20 shadow-xl">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-green-50 text-sm font-medium tracking-wide">Compliance Score</p>
                                {/* Logic for color coding the score specifically requested in ticket */}
                                <div className="flex items-baseline space-x-2">
                                    <p className={`text-3xl font-bold mt-1 ${stats.complianceScore >= 80 ? 'text-green-200' : stats.complianceScore >= 50 ? 'text-yellow-200' : 'text-red-200'}`}>
                                        {stats.complianceScore}%
                                    </p>
                                </div>
                            </div>
                            <div className={`w-12 h-12 rounded-lg flex items-center justify-center shadow-inner ${stats.complianceScore >= 80 ? 'bg-green-400' : stats.complianceScore >= 50 ? 'bg-yellow-400' : 'bg-red-400'} bg-opacity-30`}>
                                <i className="fas fa-shield-alt text-xl text-white"></i>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white bg-opacity-10 backdrop-blur-md rounded-xl p-6 hover:bg-opacity-20 transition-all border border-white border-opacity-20 shadow-xl">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-green-50 text-sm font-medium tracking-wide">Expiring Soon</p>
                                <p className="text-3xl font-bold mt-1 text-orange-200">{stats.expiringSoon}</p>
                            </div>
                            <div className="w-12 h-12 bg-orange-400 bg-opacity-30 rounded-lg flex items-center justify-center shadow-inner">
                                <i className="fas fa-clock text-xl text-white"></i>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white bg-opacity-10 backdrop-blur-md rounded-xl p-6 hover:bg-opacity-20 transition-all border border-white border-opacity-20 shadow-xl">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-green-50 text-sm font-medium tracking-wide">Overdue</p>
                                <p className="text-3xl font-bold mt-1 text-red-200">{stats.overdue}</p>
                            </div>
                            <div className="w-12 h-12 bg-red-400 bg-opacity-30 rounded-lg flex items-center justify-center shadow-inner">
                                <i className="fas fa-exclamation-circle text-xl text-white"></i>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default HeroStats;
